import React from 'react';
import { hasAccessToFlutterDRS, isFlutterSettingsAssigned } from '../utils/feature_mapping';
import { clearLocalStorage, isAdaptiveAssigned, redirectToStudentRoute } from '../utils/web-helper';


export default class BackButton extends React.Component {
  constructor(props){
    super(props);
  }

  // added events on click back button
  capitalizeString = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // [AI GENERATED CODE] - Updated backHandler to support preventRoleSwitch prop
  backHandler = (path) => {
    let currentCourse = this.props.currentCourse && this.props.currentCourse.subject_code;
    if(this.props.backHandler){
      this.props.backHandler();
      return;
    }

    if (path.includes('student-form')) window.history.back();
    else {
      if (this.props.preventRoleSwitch && hasAccessToFlutterDRS()) {
        location.href = '/';
      } else {
        if (isFlutterSettingsAssigned()) {
          clearLocalStorage('addChildOnboardingInProgress', false);
          redirectToStudentRoute('/', true);
        } else {
          redirectToStudentRoute(
            currentCourse == 'math' ? '/math' : '/english'
          );
        }
      }
    }
    let pageName = path.includes('topic')? 'Curriculum' : path.toLowerCase().includes('todo_list?')? 'Todo_list' : this.capitalizeString(path);
    trackAnalyticsEvent(pageName + ' Section Closed', {'Variation': 'Bitesize 3.0'});
  }

  isAdaptive = () => {
    const currPageName = window.location.hash.includes('topic')? 'Curriculum' : '';
    if(isAdaptiveAssigned() && currPageName == 'Curriculum'){
      return true;
    }
    return false;
  }

  render() {
    
    const className = (this.isAdaptive()) ? "adaptive-back-btn" : "back-btn";
    return (
      <a href="javascript:void(0)" className={className} onClick={(e) =>(this.backHandler(window.location.hash.slice(2)))}>
      </a>
    )
  }
}